/* tslint:disable: max-line-length */
import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Http, Headers, URLSearchParams } from '@angular/http';
import { Store } from '@ngrx/store';
import { IAppState } from '../app.state';
import { showToast } from '../visual/visual.actions';
import { Config } from '../universal-config';

@Component({
  selector: 'short-url',
  styles: [`
    .nns-share-loader {
      min-height:76px;
    }
    .nns-share-loader .fill {
      fill:#c9cdce;
    }
    .nns-share-loader .icon {
      animation:rotation linear 1s infinite;
      -webkit-animation:rotation linear 1s infinite;
    }

    @keyframes rotation {
        0% {transform:rotate(0deg);}
        100% {transform:rotate(360deg);}
    }
    @-webkit-keyframes rotation {
        0% {transform:rotate(0deg);}
        100% {transform:rotate(360deg);}
    }

    .short-url-info {
      font-size: 12px;
      font-weight: bold;
      height: 36px;
      line-height: 36px;
      text-align: center;
    }
  `],
  template: `
    <div class="nns-share-loader" flex layout="row" layout-align="center center"
      *ngIf="!shortUrl"
    >
      <svg class="icon" width="24" height="24" viewBox="0 0 24 24" flex="none">
        <path class="fill" d="M8,0 C3.581722,0 0,3.581722 0,8 C0,12.418278 3.581722,16 8,16 C12.418278,16 16,12.418278 16,8 C16,5.85026384 15.1468139,3.83310545 13.6568542,2.34314575 C13.26633,1.95262146 12.633165,1.95262146 12.2426407,2.34314575 C11.8521164,2.73367004 11.8521164,3.36683502 12.2426407,3.75735931 C13.3612458,4.87596444 14,6.38614896 14,8 C14,11.3137085 11.3137085,14 8,14 C4.6862915,14 2,11.3137085 2,8 C2,4.6862915 4.6862915,2 8,2 C8.55228475,2 9,1.55228475 9,1 C9,0.44771525 8.55228475,0 8,0 Z" transform="translate(4 4)"/>
      </svg>
    </div>
    <nns-input class="nns-input-placeholder small" *ngIf="shortUrl">
      <input  #input class="nns-animated" type="text"
        (click)="selectUrl($event)"
        [(ngModel)]="shortUrl" readonly/>
    </nns-input>
    <nns-button *ngIf="shortUrl && !isShowCopied" class="full-width text-colored"
      (click)="copy($event)" text="Copy link"></nns-button>
    <div class="short-url-info" *ngIf="isShowCopied">COPIED!</div>
  `,
})
export class ShortUrlComponent implements OnInit {
  @Input() url;
  @Input() share;
  shortUrl;
  @ViewChild('input') input;
  isShowCopied = false;

  constructor(
    public _http: Http,
    public _store: Store<IAppState>,
    public _config: Config
  ) {}

  ngOnInit() {
    const domain = this.share.instance.org && this.share.instance.org.domain ? this.share.instance.org.domain : null
    const urlSearchParams = new URLSearchParams();
    urlSearchParams.append('url', this.getShareUrl());
    if (domain) {
      urlSearchParams.append('domain', domain);
    }
    const body = urlSearchParams.toString();

    this._http.post(this._config.get('SHORT_URL_SERVICE'), body, {
      headers: new Headers({
        'Accept': '*/*',
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    }).toPromise()
      .then((response) => {
        const result = response.json();
        if (result && result.short_url) {
          this.shortUrl = result.short_url;
        } else {
          this.shortUrl = undefined;
        }
      }).catch((err) => {
        this.shortUrl = undefined;
      });
  }

  selectUrl(event) {
    event.target.setSelectionRange(0, this.shortUrl.length);
  }

  copy(event) {
    event.preventDefault();
    event.stopPropagation();
    this.input.nativeElement.focus();
    this.input.nativeElement.setSelectionRange(0, this.shortUrl.length);
    document.execCommand('copy');
    this.isShowCopied = true;
    setTimeout(() => {
      this.isShowCopied = false;
    }, 2000);
  }

  getShareUrl() {
    return this.url;
  }
}
